import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { DEFAULT_SETTINGS, mergeSettings } from "@/lib/site";

export function useSiteData() {
  const preview = typeof window !== "undefined" && sessionStorage.getItem("kn_preview") === "1";
  const query = useQuery({
    queryKey: ["site", preview],
    queryFn: async () => {
      const { data } = await api.get("/site", preview ? { params: { preview: 1 } } : undefined);
      return data;
    },
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });

  const settings = query.data ? mergeSettings(query.data.settings) : DEFAULT_SETTINGS;
  const services = query.data?.services?.length ? query.data.services : DEFAULT_SERVICES_FALLBACK;
  return {
    settings,
    services,
    whatsappConsentEnabled: !!query.data?.whatsappConsentEnabled,
    isLoading: query.isLoading,
    isError: query.isError,
    refetch: query.refetch,
  };
}

const DEFAULT_SERVICES_FALLBACK = [
  { id: "prima-visita", mode: "studio", order: 1, active: true, name: "Prima visita nutrizionale completa", price: 110, duration: 60, interval: 60, tagline: "Il punto di partenza del tuo percorso.", includes: [], note: "" },
  { id: "controllo-nutrizionale", mode: "studio", order: 2, active: true, name: "Controllo nutrizionale completo", price: 80, duration: 45, interval: 30, tagline: "Manteniamo la rotta insieme.", includes: [], note: "" },
  { id: "check-composizione", mode: "studio", order: 3, active: true, name: "Check composizione corporea", price: 50, duration: 30, interval: 30, tagline: "Un controllo rapido dei tuoi parametri.", includes: [], note: "Importante: questo servizio non include l'elaborazione o la revisione del piano alimentare." },
  { id: "prima-consulenza-online", mode: "online", order: 4, active: true, name: "Prima consulenza nutrizionale online", price: 90, duration: 45, interval: 30, tagline: "Il percorso K Nutrition, ovunque tu sia.", includes: [], note: "" },
  { id: "controllo-online", mode: "online", order: 5, active: true, name: "Controllo nutrizionale online", price: 60, duration: 30, interval: 30, tagline: "Continuità del percorso a distanza.", includes: [], note: "" },
];
